var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreezeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3C6.15 3 3 6.15 3 10C3 13.85 6.15 17 10 17C13.85 17 17 13.85 17 10C17 6.15 13.85 3 10 3ZM10 4.07692C13.2577 4.07692 15.9231 6.74231 15.9231 10C15.9231 13.2577 13.2577 15.9231 10 15.9231C6.74231 15.9231 4.07692 13.2577 4.07692 10C4.07692 6.74231 6.74231 4.07692 10 4.07692Z",
    fill: "#2968C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0104 8.06066C13.2056 7.8654 13.2056 7.54882 13.0104 7.35355C12.8151 7.15829 12.4985 7.15829 12.3033 7.35355L10.1568 9.49999L8.01041 7.35356C7.81515 7.1583 7.49857 7.1583 7.30331 7.35356C7.10804 7.54882 7.10804 7.8654 7.30331 8.06067L9.44973 10.2071L7.35352 12.3033C7.15826 12.4986 7.15826 12.8151 7.35352 13.0104C7.54879 13.2057 7.86537 13.2057 8.06063 13.0104L10.1568 10.9142L12.2531 13.0104C12.4483 13.2057 12.7649 13.2057 12.9602 13.0104C13.1554 12.8152 13.1554 12.4986 12.9602 12.3033L10.8639 10.2071L13.0104 8.06066Z",
    fill: "#2968C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreezeIcon);
export default __webpack_public_path__ + "static/media/freeze-icon.65586f7f11433afc7ca1bdc27aa8073e.svg";
export { ForwardRef as ReactComponent };